var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-none"},[(_vm.globalStyles.navbar.block)?_c(_vm.globalStyles.navbar.block.component,{tag:"component",attrs:{"section":_vm.globalStyles.navbar.block}}):_vm._e()],1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }